import { PLATFORM } from 'aurelia-pal';
/**
 * The definition of all the routes of the app.
 * @type {AppNavigation}
 */
export const NAVIGATION = {
  avatar: [
    {
      name: 'logout',
      route: ['logout'],
      moduleId: PLATFORM.moduleName('libs/oal/containers/logout/logout.container'),
      title: 'Logout',
      settings: {
        hideMenu: true,
      },
    },
  ],
  main: [],
  sub: [],
  unmapped: [
    {
      name: 'home',
      route: [''],
      moduleId: PLATFORM.moduleName('modules/app/containers/home/home.container'),
    },
    {
      name: 'login',
      route: ['login'],
      moduleId: PLATFORM.moduleName('libs/oal/containers/login/login.container'),
      title: 'Login',
      settings: {
        hideMenu: true,
        requiresAuthorization: false,
      },
    },
  ],
};
